{
    "LicenseManagement_Title": "BEHEER VAN BEDRIJFSLICENTIES",
    "LicenseManagement_Heading_License": "Licentie",
    "LicenseManagement_Heading_Quantity": "Hoeveelheid",
    "LicenseManagement_Essentials": "Benodigdheden",
    "LicenseManagement_Essentials_MST": "CXA-standaard",
    "LicenseManagement_Professional": "Professioneel",
    "LicenseManagement_Professional_MST": "CXA Premium",
    "LicenseManagement_Enterprise": "Onderneming",
    "LicenseManagement_Enterprise_MST": "CXA Gevorderd",
    "LicenseManagement_CallCentreAgent": "Callcenter Agent",
    "LicenseManagement_CallCentreAgent_MST": "CXE Premium",
    "LicenseManagement_CallCentreSupervisor": "Supervisor callcenter",
    "LicenseManagement_CallCentreSupervisor_MST": "CXE Gevorderd",
    "LicenseManagement_Validation_Number": "Moet een geldig nummer zijn",
    "LicenseManagement_Validation_Limit": "Overschrijdt CME Licentie Cap. Moet minder zijn dan of gelijk aan {}",
    "LicenseManagement_Validation_Limit_Reached": "Overschrijdt CME-licentieplafond. Geen licenties meer beschikbaar",
    "LicenseManagement_Validation_MAX_LIMIT": "Aantal overschrijdt maximaal toegestaan aantal",
    "LicenseManagement_Validation_POSITIVE_NUMBER": "Getal moet positief zijn",
    "NAME": "LicenseManagement",
    "LicenseManagement_CXIntegration": "CX-integratie"
}